<script setup lang="ts">
import { usePageTitle } from '@/shared/composables/usePageTitle';

usePageTitle('Page Not Found');

const error = {
  statusCode: 404,
  statusMessage: 'Not found',
  message: 'The page you\'re looking for doesn\'t exist.',
};
</script>

<template>
  <UError
    :error="error"
    :clear="false"
    data-testid="error-page-404"
  >
    <template #links>
      <UButton
        to="/"
        size="lg"
        color="primary"
        label="Go home"
        data-testid="error-back-to-home-button"
      />
    </template>
  </UError>
</template>
